import { defineStore } from "pinia";
import axios from "axios";
import { API_URL } from "@/config/api";

export const useDestinationMasterStore = defineStore("destinationMaster", {
  state: () => ({
    prefectures: [],
    countries: [],
    countryAliases: [],
    loaded: false,
  }),

  getters: {
    // 名前リスト（サジェスト用）
    prefectureNames: (state) => state.prefectures.map((p) => p.PREFECTURE_NMV),
    countryNames: (state) => state.countries.map((c) => c.COUNTRY_NMV),

    // 都道府県名 → ISO コード（JP01-JP47）マッピング
    // ISO コードは SORT_ORDER から計算：1→JP01, 47→JP47
    prefectureToIsoCode: (state) => {
      const map = {};
      state.prefectures.forEach((p) => {
        if (p.SORT_ORDER) {
          const code = "JP" + String(p.SORT_ORDER).padStart(2, "0");
          map[p.PREFECTURE_NMV] = code;
          // 「都」「道」「府」「県」なし表記も登録
          const short = p.PREFECTURE_NMV.replace(/[都道府県]$/, "");
          if (short !== p.PREFECTURE_NMV) map[short] = code;
        }
      });
      return map;
    },

    // ISO コード → 都道府県名（短縮形）マッピング
    isoCodeToPrefecture: (state) => {
      const map = {};
      state.prefectures.forEach((p) => {
        if (p.SORT_ORDER) {
          const code = "JP" + String(p.SORT_ORDER).padStart(2, "0");
          map[code] = p.PREFECTURE_NMV.replace(/[都道府県]$/, "");
        }
      });
      return map;
    },

    // 国名（日本語）→ ISO コードマッピング
    countryToIsoCode: (state) => {
      const map = {};
      state.countries.forEach((c) => {
        if (c.ISO_CODE) map[c.COUNTRY_NMV] = c.ISO_CODE;
      });
      return map;
    },

    // ISO コード → 国名（日本語）マッピング
    isoCodeToCountryName: (state) => {
      const map = {};
      state.countries.forEach((c) => {
        if (c.ISO_CODE && !map[c.ISO_CODE]) map[c.ISO_CODE] = c.COUNTRY_NMV;
      });
      return map;
    },
  },

  actions: {
    async fetchAll() {
      if (this.loaded) return;
      try {
        const [prefRes, cntRes] = await Promise.all([
          axios.get(`${API_URL}/master/prefectures`),
          axios.get(`${API_URL}/master/countries`),
        ]);
        this.prefectures = prefRes.data;
        this.countries = cntRes.data;

        try {
          const { data } = await axios.get(`${API_URL}/master/country-aliases`);
          this.countryAliases = data;
        } catch (aliasErr) {
          console.warn("country_alias_master is not available:", aliasErr);
          this.countryAliases = [];
        }

        this.loaded = true;
      } catch (err) {
        console.error("マスターデータ取得エラー:", err);
      }
    },
  },
});
